import EventEmitter from '../utils/EventEmitter';
import dispatcher from '../dispatcher';

var groupId = -1;
var hidden = false;

var eventEmitter = new EventEmitter();

var _handleEvent = function(e) {
	if (e.type === '3d:show') {
		hidden = false;
	}

	if (e.type === '3d:hide' ||
		e.type === '3d:instant-hide') {
		hidden = true;
		groupId = -1;

		eventEmitter.dispatch();
	}

	if (e.type === 'bg-objects:set-group') {
		if (groupId === e.groupId) return;
		if (hidden) return;

		groupId = e.groupId;
		eventEmitter.dispatch();
	}
}

var getData = function() {
	return {
		groupId: groupId,
		hidden: hidden
	}
}

var _init = function() {
	dispatcher.subscribe(_handleEvent);
}

_init();

export default {
	subscribe: eventEmitter.subscribe.bind(eventEmitter),
	unsubscribe: eventEmitter.unsubscribe.bind(eventEmitter),
	getData: getData
};